<div>
  <div class="title" [innerHTML]="'MyProfile_GDPR_TermsHeader' | translate"></div>
  <div class="inner_content" #pdfContainer></div>
  <div class="pdf_block">
    <p class="pdf_block_title">{{ 'MyProfile_AS_Pdf_Terms' | translate }}</p>
    <ul class="list-inline">
      <li class="list-inline-item">
        <a (click)="onLanguageClick('en')">{{ 'MyProfile_Language_English' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('fr')">{{ 'MyProfile_Language_French' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('de')">{{ 'MyProfile_Language_German' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('ja')">{{ 'MyProfile_Language_Japanese' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('pt')">{{ 'MyProfile_Language_Portuguese' | translate }},</a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('es')">{{ 'MyProfile_Language_Spanish' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('it')">{{ 'MyProfile_Language_Italian' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('ru')">{{ 'MyProfile_Language_Russian' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('ko')">{{ 'MyProfile_Language_Korean' | translate }}, </a>
      </li>
      <li class="list-inline-item">
        <a (click)="onLanguageClick('zh-hans')">{{ 'MyProfile_Language_Chinese' | translate }}</a>
      </li>
    </ul>
  </div>
</div>
